import React, { FC, ReactElement } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import psllogo from "../assets/psllogo.png";
import { useTheme } from "@mui/material";
import ExploreIcon from "@mui/icons-material/Explore";
import { brandingSettings } from "../branding";
interface i_props {
  logoUrl: string;
  onStartJoyRide: () => void;
}
const Navbar: FC<i_props> = ({ logoUrl, onStartJoyRide }): ReactElement => {
  const theme = useTheme();
  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor:
          theme.palette.mode === "dark"
            ? brandingSettings.headercolorDark
            : brandingSettings.headercolor,
      }}
    >
      <Toolbar>
        <img src={logoUrl} alt="Persistent logo" width={30} />
        <Typography
          variant="h6"
          noWrap
          sx={{
            fontFamily: "Poppins",
            fontWeight: 900,
            color:
              theme.palette.mode === "dark"
                ? brandingSettings.textcolorPrimaryDark
                : "inherit",
            textDecoration: "none",
            padding: 2,
            fontSize: "15px",
            pr: 1,
            flex: 1,
          }}
        >
          Persistent - Playground
        </Typography>
        <Tooltip title="Start virtual tour">
          <IconButton onClick={onStartJoyRide} sx={{ marginRight: 3 }}>
            <ExploreIcon className="explore" />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
